import {CalendarStyles} from "@/enums/CalendarStyles";
import {CalendarTypeEnum} from "@/enums/CalendarTypeEnum";
import {OrientationTypes} from "@/enums/OrientationTypes";

export default {
  name: "PrintableCalendarPagination",
  props: {
    printCalendarStyle: {
      type: String
    },
    printCalendarFormat: {
      type: String
    },
    isPdfLoading: {
      type: Boolean
    },
    pagination: {
      type: Object
    },
    pdfOrientation: {
      type: String
    },
    type: {
      type: String
    }
  },
  computed: {
    printCalendarStyles() {
      return CalendarStyles;
    },
    typeToLabel() {
      return CalendarTypeEnum;
    },
    isPrintCalendar() {
      return this.printCalendarStyle === this.printCalendarStyles.calendar;
    },
    isPrintList() {
      return this.printCalendarStyle === this.printCalendarStyles.list;
    },
    isWeek() {
      return this.printCalendarFormat === this.typeToLabel.week;
    },
    is2Weeks() {
      return this.printCalendarFormat === this.typeToLabel['2weeks'];
    },
    isDay() {
      return this.printCalendarFormat === this.typeToLabel.day;
    },
    isPdfLandscape() {
      return this.pdfOrientation === OrientationTypes.Landscape;
    },
  },
  methods: {
    inputCalendarPrint() {
      this.$emit("inputCalendarPrint", this.type)
    }
  }
}